import { createContext, useState, useEffect } from "react";
import { getErrorMessageFromError } from "../../components/ErrorMessage";
import { useApp } from "../../hooks/useApp";
import { useNavigate } from "react-router-dom";
import {
  saveMessageTemplateRequest,
  updateMessageTemplateRequest,
  getMessageTemplateRequest,
  deleteMessageTemplateRequest,
} from "../../services/templates/MessageTemplatesService";

const TemplatesEmailDataContext = createContext();

const TemplatesEmailDataContextProvider = ({ children }) => {
  const [listTemplatesEmail, setListTemplatesEmail] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [templateIdToDelete, setTemplateIdToDelete] = useState(0);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

  const [page, setPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const {
    setSuccessMsg,
    setErrorMsg,
    setLoading,
    messageUser,
    loading,
    authenticate,
  } = useApp();

  const navigate = useNavigate();

  const handleCancel = () => navigate(-1);

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  useEffect(() => {
    setTimeout(() => loadTemplatesEmail(null, null), 100);
  }, [page]);

  useEffect(() => {
    if (page === 0) setTimeout(() => loadTemplatesEmail(null, null), 100);
    else setPage(0);
  }, [rowsPerPage]);

  const handleFormSubmit = async (values) => {
    try {
      const input = { ...values, type: "EMAIL", active: values.active ? 1 : 0 };
      setLoading(true);
      if (values.id) {
        await updateMessageTemplateRequest(input);
        setSuccessMsg("Editado con éxito");
      } else {
        await saveMessageTemplateRequest(input);
        setSuccessMsg("Creado con éxito");
      }
      setLoading(false);
      if (page === 0) setTimeout(() => loadTemplatesEmail(null, null), 100);
      else setPage(0);
      handleCancel();
    } catch (error) {
      setErrorMsg(getErrorMessageFromError(error) || "Error desconocido");
      setLoading(false);
    }
  };

  const loadTemplatesEmail = async (criterio, active) => {
    if (!authenticate) return;
    try {
      setLoading(true);
      setListTemplatesEmail([]);
      const params = { criterio, type: "EMAIL", active, page, size: rowsPerPage };
      const response = await getMessageTemplateRequest(params);
      setTotalItems(response.totalElements);
      setListTemplatesEmail(
        response.content.map((t) => ({
          id: t.id,
          name: t.name,
          subject: t.subject || "",
          template: t.template,
          type: t.type,
          active: t.active,
          authorized: t.authorized,
        }))
      );
      setLoading(false);
    } catch (error) {
      setErrorMsg(getErrorMessageFromError(error));
      setLoading(false);
    }
  };

  const openDeleteConfirmation = (templateId) => {
    setTemplateIdToDelete(templateId);
    setShowDeleteConfirmation(true);
  };

  const closeDeleteConfirmation = () => {
    setTemplateIdToDelete(null);
    setShowDeleteConfirmation(false);
  };

  const handleDeleteConfirmed = async () => {
    closeDeleteConfirmation();
    if (templateIdToDelete) await handleDelete(templateIdToDelete);
  };

  const handleDelete = async (templateId) => {
    try {
      setLoading(true);
      await deleteMessageTemplateRequest(templateId);
      setSuccessMsg("Eliminado con éxito");
      setLoading(false);
      if (page === 0) setTimeout(() => loadTemplatesEmail(null, null), 100);
      else setPage(0);
    } catch (error) {
      setErrorMsg(getErrorMessageFromError(error) || "Error desconocido");
      setLoading(false);
    }
  };

  return (
    <TemplatesEmailDataContext.Provider
      value={{
        listTemplatesEmail,
        loadTemplatesEmail,
        loading,
        messageUser,
        selectedTemplate,
        setSelectedTemplate,
        showDeleteConfirmation,
        openDeleteConfirmation,
        closeDeleteConfirmation,
        handleDeleteConfirmed,
        handleFormSubmit,
        handleDelete,
        handleCancel,
        page,
        setPage,
        rowsPerPage,
        handleChangePage,
        handleChangeRowsPerPage,
        totalItems,
      }}
    >
      {children}
    </TemplatesEmailDataContext.Provider>
  );
};

export { TemplatesEmailDataContext, TemplatesEmailDataContextProvider };
